export default {
  subscription: 'funkwerks',
  mailing_list: 21,
  info_url: 'http://landing.tavour.com/funkwerks/',
  title: {
    in_progress: 'Funkwerks Quarterly Bottle Club',
    success: 'Congrats! You are Confirmed for Funkwerks Quarterly Bottle Club',
    subtext: 'Get hand-picked, limited release Funkwerks 750mls, delivered to your door.',
  },
  cancel_anytime: 'Once we email you about a quarter\'s selection, you\'ll always have at least 48 hours to let us know via ' +
  'email if you want to skip the beers. If needed, we\'ll cancel your subscription and confirm with a ' +
  'simple email. Real, beer loving people answer every email: please get in touch if you have any ' +
  'requests or questions.',
  review: {
    agreement: 'I agree to the <a href="https://www.tavour.com/terms-of-use" target="_blank">terms of use</a> ' +
    'and automatic billing.',
    summary: [
      'The Funkwerks Quarterly Bottle Club ',
      'Bottle Club pricing subject to change every quarter based on the brewery\'s selection. ',
      'Funkwerks and Tavour aim for $100 a quarter, with free shipping. ',
      'We will always let you know the price ahead of time and ' +
      'let you skip any box.',
    ],
    button_text: 'Join the Bottle Club!',
  },
};



// WEBPACK FOOTER //
// ./src/settings/funkwerks.js